
export default function CheckCartStatus(cartStatusCode) {

    if(cartStatusCode == 0){
        return "Success"
    }
    else if(cartStatusCode == 1){
        return "Store not available"
    }
    else if(cartStatusCode == 2){
        return "Store not matching"
    }
    else if(cartStatusCode == 3){
        return "Delivery address not available"
    }
    else if(cartStatusCode == 4){
        return "Cart not available"
    }
    else if(cartStatusCode == 5){
        return "Cart items out of stock"
    }
    else if(cartStatusCode == 6){
        return "Waiver changed"
    }
    else if(cartStatusCode == 7){
        return "Referral changed"
    }
    else if(cartStatusCode == 8){
        return "Wallet Changed"
    }
    else if(cartStatusCode == 9){
        return "Coupon Changed"
    }
    else if(cartStatusCode == 10){
        return "Nest cash changed"
    }
    else if(cartStatusCode == 11){
        return "Billing changed"
    }
    else{
        return "cart status unknown"
    }

}

const QUERY_CART_STATUS = Object.freeze({
  SUCCESS: 0,
  STORE_NOT_AVAILABLE: 1,
  STORE_NOT_MATCHING: 2,
  DELIVERY_ADDRESS_NOT_AVAILABLE: 3,
  CART_NOT_AVAILABLE: 4,
  CART_ITEMS_OUT_OF_STOCK: 5,
  WAIVER_CHANGED: 6,
  REFERRAL_CHANGED: 7,
  WALLET_CHANGED: 8,
  COUPON_CHANGED: 9,
  NEST_CASH_CHANGED: 10,
  BILLING_CHANGED: 11  
})